import {RouteDescriptor} from "../../RouteDescriptor";
import {Route} from "../../Route";
import {CurrenciesPage} from "../../../../../pages/Admin/Currencies/CurrenciesPage";
import {Role} from "../../../roles/Role";
import {defineMessage} from "react-intl";


const AdminCurrenciesRouteTitleMessage = defineMessage({
  id: "adminCurrenciesRoute.title",
  defaultMessage: "Currency management",
})

export const adminCurrencies: RouteDescriptor<Route.adminCurrencies> = {
  route: Route.adminCurrencies,
  render: CurrenciesPage,
  title: AdminCurrenciesRouteTitleMessage,
  path: '/lk/currencies',
  allowRoles: [
    Role.admin,
  ],
  redirectToHomeRoles: [
  ],
  showInSidebar: true,
}

